{
  "0_ALREADY_EXISTS": "\"{0}\"(이)가 이미 존재합니다.",
  "0_OF_1": "{1} 중 {0}",
  "ACCOUNT_ID": "계정 ID",
  "ADD": "추가",
  "ADD_REMOVE_FIELDS": "필드 추가/제거",
  "AN_ERROR_OCCURED": "오류가 발생했습니다",
  "APPLY": "적용",
  "APPLY_CHANGES": "변경 사항 적용",
  "ATTACH": "첨부",
  "ATTACH_AS_LINK": "링크로 첨부",
  "ATTACHING": "첨부 중...",
  "AUTOMATICALLY_RENAME": "자동으로 이름 변경",
  "BACK": "뒤로",
  "BROWSE": "찾아보기",
  "CANCEL": "취소",
  "CHARACTER_COUNT": "문자 수:",
  "CLOSE": "닫기",
  "CLOUD": "클라우드",
  "COMMENT": "댓글",
  "CONFIGURE_REPOSITORY_SETTINGS": "저장소 설정 구성",
  "COULD_NOT_SAVE_0": "\"{0}\"(을)를 저장할 수 없습니다.",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "\"{0}\"(을)를 저장할 수 없습니다. 파일 형식이 지원되지 않습니다.",
  "DATA": "데이터",
  "DATE": "날짜",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "날짜 필드는 {0} 형식이어야 합니다.",
  "DATE_PROVIDED_IS_INVALID": "제공된 날짜가 유효하지 않습니다.",
  "DATE_TIME": "날짜/시간",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "날짜/시간 필드는 {0} 형식이어야 합니다.",
  "DEFAULT_FOLDER": "<기본 폴더>",
  "DETAILS": "세부 정보",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "필드 변경 사항을 적용하시겠습니까?",
  "DOCUMENT_NAME_IS_EMPTY": "문서 이름이 비어 있습니다",
  "DRAG_DROP_FILE": "파일을 끌어다 놓기",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "이 폴더에 '{0}'라는 이름의 항목이 이미 있습니다. 다른 이름을 선택하십시오.",
  "ENTRY_ID": "항목 ID",
  "ENTRY_NAME": "항목 이름",
  "ENTRY_NOT_FOUND": "항목을 찾을 수 없습니다.",
  "ERROR_DOWNLOADING_DOCUMENT": "문서 다운로드 오류.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "서버에 연결하는 동안 오류가 발생했습니다.",
  "ERROR_SAVING": "저장 오류:",
  "FAILED_TO_OPEN_FOLDER": "폴더를 열지 못했습니다",
  "FAILED_TO_SAVE_COLON": "저장 실패:",
  "FAILED_TO_SAVE_PERIOD": "저장하지 못했습니다.",
  "FEEDBACK": "피드백",
  "FIELDS": "필드",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "이 파일은 최대 파일 크기 25MB를 초과합니다.",
  "FILE_EXTENSION": "파일 확장자",
  "FILE_LOCKED": "파일이 잠겨 있습니다.",
  "FILE_MODIFIED": "파일 수정됨",
  "FILE_NAME": "파일 이름",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "파일 이름에는 역슬래시를 포함할 수 없습니다",
  "FOLDER": "폴더",
  "INTEGER": "정수",
  "LIST": "목록",
  "LOADING": "로딩 중...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "긴 필드는 0에서 3,999,999,999 사이의 정수여야 합니다",
  "LONG_INTEGER": "긴 정수",
  "NAME": "이름",
  "NAME_CONFLICT": "이름 충돌",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "로그인에 도움이 필요하십니까? 도움을 받으려면 Laserfiche 관리자에게 문의하십시오.",
  "NEW_FOLDER": "새 폴더",
  "NO": "아니요",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "추가 필드가 할당되지 않았습니다",
  "NO_FOLDER_SELECTED": "선택된 폴더가 없습니다.",
  "NO_MATCHING_ENTRIES_FOUND": "일치하는 항목이 없습니다",
  "NO_MATCHING_FIELDS_FOUND": "일치하는 필드가 없습니다.",
  "NO_TEMPLATE_ASSIGNED": "할당된 템플릿이 없습니다",
  "NOT_AVAILABLE_WITH_TOKENS": "토큰으로는 사용할 수 없습니다",
  "NUMBER": "번호",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "숫자 필드는 유효한 숫자여야 합니다",
  "OK": "확인",
  "ONE_OR_MORE_FIELDS_INVALID": "하나 이상의 필드가 유효하지 않습니다.",
  "OPEN": "열기",
  "OPEN_IN_LASERFICHE": "Laserfiche에서 열기",
  "OPTIONAL": "선택 사항",
  "OR": "또는",
  "PARENT_FIELD": "상위 필드",
  "PARENT_ID": "상위 ID",
  "PARENT_NAME": "상위 이름",
  "PLEASE_SELECT_A_FOLDER": "폴더를 선택하십시오",
  "REASON_FOR_DOWNLOADING": "다운로드 사유",
  "REFRESH": "새로 고침",
  "REMOVE": "제거",
  "REMOVE_REPOSITORY": "저장소를 제거하시겠습니까?",
  "REPOSITORY": "저장소",
  "REPOSITORY_COUNT": "저장소 수",
  "REPOSITORY_ID": "저장소 ID",
  "REPOSITORY_NAME": "저장소 이름",
  "REQUIRED": "필수",
  "REQUIRED_FIELD_IS_EMPTY": "필수 필드가 비어 있습니다",
  "SAVE_CHANGES": "변경 사항 저장",
  "SAVE_TO_LASERFICHE": "Laserfiche에 저장",
  "SAVED_TO_LASERFICHE": "Laserfiche에 저장됨",
  "SAVED_TO_LASERFICHE_COLON": "Laserfiche에 저장됨:",
  "SAVED_WITH_MISSING_METADATA": "메타데이터 누락 상태로 저장됨:",
  "SAVING": "저장 중...",
  "SEARCH_FIELDS": "검색 필드",
  "SELECT": "선택",
  "SELECT_REASON": "사유 선택",
  "SELF_HOSTED": "셀프 호스팅",
  "SESSION_COUNT": "세션 수",
  "SETTINGS": "설정",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "짧은 필드는 0에서 64999 사이의 정수여야 합니다",
  "SIGN_IN": "로그인",
  "SIGN_IN_TO_LASERFICHE": "Laserfiche에 로그인",
  "SIGN_OUT": "로그아웃",
  "SIGNING_IN": "로그인 중...",
  "SIGNING_OUT": "로그아웃 중...",
  "SKIP_THIS_FILE": "이 파일 건너뛰기",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "문제가 발생했습니다. 나중에 다시 시도하십시오.",
  "SUBMIT": "제출",
  "SUGGESTION": "제안",
  "TEMPLATE": "템플릿",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "템플릿을 불러오지 못했습니다.",
  "TEXT": "텍스트",
  "THANK_YOU_FOR_SUBMISSION": "제출해 주셔서 감사합니다!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "이 필드는 최대 {0}자까지 허용됩니다.",
  "THIS_FOLDER_IS_EMPTY": "이 폴더는 비어 있습니다.",
  "TIME": "시간",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "시간 필드는 {0} 형식이어야 합니다.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "모든 필드를 불러올 수 없습니다:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "저장소 정보를 가져올 수 없습니다:",
  "UNKNOWN_ERROR": "알 수 없는 오류입니다.",
  "USER_NAME": "사용자 이름",
  "YES": "예"
}
